import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmma76xjhy: FaireProductEntity = {
  token: "p_hmma76xjhy",
  type: "product",
  name: "Fiji 17 oz. Stack",
  brandName: "Hospitality Glass",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9a2cc734ca976d1d92bc83de33c8ab11b4f2dbaf30db1ca0633ccebbad311e04.png",
  priceDollars: 4.91,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/22255ec01b6063498142712f464e8195d3c0edb4be71cb3d49d77738ac1be22d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
